export const aciShareBathroom = {
    iconName: 'share-bathroom',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M3.659 11.043a1.802 1.802 0 011.274-.527h14.134a1.802 1.802 0 010 3.603H4.933a1.802 1.802 0 01-1.274-3.076zm1.274.473a.802.802 0 000 1.603h14.134a.802.802 0 000-1.603H4.933z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.721 3.551a1.616 1.616 0 011.143-.473h12.274a1.616 1.616 0 011.616 1.616v6.338a.5.5 0 11-1 0V4.694a.616.616 0 00-.616-.616H5.864a.616.616 0 00-.616.616v6.338a.5.5 0 11-1 0V4.694c0-.429.17-.84.473-1.143z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.24 6.805a.5.5 0 01.5.5v1.28a.5.5 0 11-1 0v-1.28a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.605 8.586a.5.5 0 01.5-.5h4.27a.5.5 0 01.5.5c0 .605-.234 1.175-.709 1.586-.47.407-1.13.622-1.926.622s-1.457-.215-1.926-.622a2.058 2.058 0 01-.709-1.586zm1.109.5c.06.125.146.236.255.33.243.211.65.378 1.271.378.621 0 1.028-.167 1.271-.378.11-.094.195-.205.255-.33H6.714zM15.762 6.805a.5.5 0 01.5.5v1.28a.5.5 0 11-1 0v-1.28a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.127 8.586a.5.5 0 01.5-.5h4.269a.5.5 0 01.5.5c0 .605-.233 1.175-.708 1.586-.47.407-1.13.622-1.926.622s-1.457-.215-1.927-.622a2.058 2.058 0 01-.708-1.586zm1.108.5c.06.125.146.236.255.33.243.211.65.378 1.271.378.622 0 1.029-.167 1.272-.378.109-.094.194-.205.255-.33h-3.053zM6.941 13.156a.5.5 0 01.5.5v6.77a.5.5 0 01-1 0v-6.77a.5.5 0 01.5-.5zM17.58 13.156a.5.5 0 01.5.5v6.77a.5.5 0 01-1 0v-6.77a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.41 20.426a.5.5 0 01-.5.5H5.976a.5.5 0 010-1H7.91a.5.5 0 01.5.5zM19.047 20.426a.5.5 0 01-.5.5h-1.934a.5.5 0 110-1h1.934a.5.5 0 01.5.5z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
